'use client';

import { useMediaQuery } from 'usehooks-ts';

export const useCanAutoFocus = () => useMediaQuery('(hover: hover) and (pointer: fine)');
